import {StammdatenAdresseAusland} from './stammdatenAdresseAusland';
import {StammdatenAdresseInland} from './stammdatenAdresseInland';
import {StammdatenAdresseGrossempfaenger} from './stammdatenAdresseGrossempfaenger';
import {StammdatenAdressePostfach} from './stammdatenAdressePostfach';


export interface StammdatenAdresse {
    /**
     * * 0: Inlandsadresse * 1: Auslandsadresse * 2: Postfachadresse * 3: Grossempfaengeradresse
     */
    typ?: StammdatenAdresse.TypEnum;
    standard?: boolean;
    inland?: StammdatenAdresseInland;
    ausland?: StammdatenAdresseAusland;
    postfach?: StammdatenAdressePostfach;
    grossempfaenger?: StammdatenAdresseGrossempfaenger;
}

export namespace StammdatenAdresse {
    export type TypEnum = 0 | 1 | 2 | 3;
    export const TypEnum = {
        NUMBER_0: 0 as TypEnum,
        NUMBER_1: 1 as TypEnum,
        NUMBER_2: 2 as TypEnum,
        NUMBER_3: 3 as TypEnum
    };
}


